import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { TThunkDispatch } from '../../../types/redux';
import { leaveContacts } from '../../../actions/contacts';
import { EFormStatus, TLeaveContactsFormResetHandler, TLeaveContactsFormSubmitHandler } from '../types';
import { getLeaveContactsRequestParams } from './getLeaveContactsRequestParams';
import { ESentFrom } from '../../../repositories/e2e-deal-form/entities/availability/LeaveContactsV2RequestSchema';

interface IUseLeaveContactsDialogContainerPropsDeps {
  onClose: () => void;
  onSendForm?: () => void;
  calledFrom: ESentFrom;
}

interface IUseLeaveContactsDialogContainerPropsResult {
  status: EFormStatus;
  tryAgainHandler: (resetForm: TLeaveContactsFormResetHandler) => () => void;
  closeHandler: (resetForm: TLeaveContactsFormResetHandler) => () => void;
  sendHandler: TLeaveContactsFormSubmitHandler;
}

export function useLeaveContactsDialogContainerProps({
  onClose,
  onSendForm,
  calledFrom,
}: IUseLeaveContactsDialogContainerPropsDeps): IUseLeaveContactsDialogContainerPropsResult {
  const dispatch = useDispatch<TThunkDispatch>();
  const [status, setStatus] = useState<EFormStatus>(EFormStatus.Pending);

  const tryAgainHandler = (resetForm: TLeaveContactsFormResetHandler) => () => {
    resetForm();
    setStatus(EFormStatus.Pending);
  };

  const closeHandler = (resetForm: TLeaveContactsFormResetHandler) => () => {
    resetForm();
    setStatus(EFormStatus.Pending);
    onClose();
  };

  const sendHandler: TLeaveContactsFormSubmitHandler = async (value, helpers) => {
    onSendForm?.();

    try {
      await dispatch(leaveContacts(getLeaveContactsRequestParams({ formValue: value, sentFrom: calledFrom })));

      helpers.resetForm();
      setStatus(EFormStatus.Succeed);
    } catch (error) {
      setStatus(EFormStatus.Failed);
    }
  };

  return {
    status,
    tryAgainHandler,
    closeHandler,
    sendHandler,
  };
}
